import { useState, useEffect } from "react";

export function useHasAcceptedCookie(key: string) {
  const [hasAcceptedThird, setHasAcceptedThird] = useState<any>(false);

  useEffect(() => {
    const cookie = localStorage.getItem(key);
    if (cookie) {
      setHasAcceptedThird(true);
    }
  }, [key]);

  const handleChange = (newValue: boolean) => {
    if (newValue) {
      localStorage.setItem(key, "true");
      setHasAcceptedThird(true);
    } else {
      localStorage.removeItem(key);
      setHasAcceptedThird(false);
    }
  };

  return [hasAcceptedThird, handleChange];
}
